import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, CheckCircle } from "lucide-react";

interface NotificationProps {
  message: string;
  type: "error" | "success";
  isVisible: boolean;
  onClose: () => void;
  duration?: number;
}

export function Notification({
  message,
  type,
  isVisible,
  onClose,
  duration = 3000,
}: NotificationProps) {
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -20, opacity: 0 }}
          onClick={onClose}
          className={`fixed left-1/2 top-6 z-[100] max-w-[90vw] -translate-x-1/2 cursor-pointer rounded-2xl px-5 py-3 shadow-2xl ring-1 backdrop-blur ${
            type === "error" ? "bg-destructive text-foreground ring-card-muted-ring" : "bg-green-600 text-foreground ring-card-muted-ring"
          }`}
        >
          <div className="flex items-center gap-2.5">
            {type === "error" ? (
              <X className="size-5" />
            ) : (
              <CheckCircle className="size-5" />
            )}
            <p className="max-w-[55ch] text-sm font-medium leading-snug">{message}</p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
